import {
  fetchCheckCouponTrustPilot,
  fetchPersistentCartApiTrustPilot,
  reviewTrustPilotActions,
  selectPersistentCartPayloadTrustPilot,
} from "@/redux/slice/ReviewTrustPilotSlice";
import {ListenerEffectAPI} from "@reduxjs/toolkit";
import type {AppDispatch, RootState} from "@/redux/store";
import {getPersistentCartUuid} from "@/utils/hooks/usePersistentCart";

export const TRUST_PILOT_PERSISTENT_CART_ACTIONS = [
  reviewTrustPilotActions.clearCartContents,
  reviewTrustPilotActions.setToggleItem,
  reviewTrustPilotActions.setChoseRatingItem,
  reviewTrustPilotActions.selectReviewsForTargetRating,
  reviewTrustPilotActions.setQuickRatingSelection,
  reviewTrustPilotActions.removeAllSelectedReviewsByCompany,
  reviewTrustPilotActions.removeReviewByCompany,
  reviewTrustPilotActions.resetCoupon,
  reviewTrustPilotActions.setUserDataBulk,
  fetchCheckCouponTrustPilot.fulfilled,
];

export const handleTrustPilotPersistentCart = (
  listenerApi: ListenerEffectAPI<RootState, AppDispatch>,
) => {
  const state = listenerApi.getState();
  const payload = selectPersistentCartPayloadTrustPilot(state);
  const uuid = getPersistentCartUuid();

  if (uuid !== null) {
    listenerApi.dispatch(
      fetchPersistentCartApiTrustPilot({ uuid, data: payload }),
    );
  }
};
